import React from 'react';
import { List } from 'immutable';
import SportItemGeneral from './SportItemGeneral.jsx';
import Loading from '../../Loading';
import { List as MovableList, arrayMove } from 'react-movable';
import { observer } from 'mobx-react';
import { observable, makeObservable } from 'mobx';
import {
    LabelHeader,
    SportList,
    SportListItem
} from './SportGeneral.style';

//TODO .tsx file
// interface PropsType {
//     onMoveSportsRequest: () => void,
//     sports: Map<string, any>,
//     moveStatus: string
// }

function sortSports(sports) {
    return sports.sortBy(
        map => parseInt(map.get('displayOrder'),10)
    ).reverse().toArray();
}
@observer
class SportGeneral extends React.Component {
    static defaultProps = {
        sports: List()
    };

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.sports !== prevProps.sports) {
            this.items = sortSports(this.props.sports);
        }
    }

    @observable items = sortSports(this.props.sports);

    onChange = ({ oldIndex, newIndex }) => {
        const list = arrayMove(this.items, oldIndex, newIndex);
        const sport = this.items[oldIndex];

        const updateList = {};

        list.map((item, idx) => {
            if (100 - idx !== parseInt(item.get('displayOrder'),10)) {
                updateList[ item.get('id') ] = {
                    id: item.get('id'),
                    displayOrder: 100 - idx
                };
            }
        });

        this.props.onMoveSportsRequest(sport.getIn([ 'sport', 'id' ]), updateList);
    }
    render() {
        return (
            <div className="row">
                <div className="col-12">
                    <LabelHeader>
                        Sports display order
                    </LabelHeader>
                    <MovableList
                        values={this.items}
                        onChange={this.onChange}
                        renderList={({ children, props }) => (
                            <SportList
                                {...props}
                            >{children}</SportList>
                        )}
                        renderItem={({ value: item, props, isDragged, isSelected }) => {

                            return (
                                <SportListItem
                                    key={ item.get('id') }
                                    {...props}
                                    isDragged = {isDragged}
                                    isSelected = {isSelected}
                                    style={{
                                        ...props.style
                                    }}
                                >
                                    <SportItemGeneral
                                        {...props}
                                        name={item.get('name')}
                                        isDragged = { isDragged }
                                    />
                                </SportListItem>
                            );
                        }}
                    />
                    <Loading active={ this.props.moveStatus === 'IN_PROGRESS' } />
                </div>
            </div>
        );
    }
}
export default SportGeneral;
